// extracted by mini-css-extract-plugin
export var header = "contacts-module--header--_zlX-";
export var contacts = "contacts-module--contacts--10r4U";
export var wrapper = "contacts-module--wrapper--3m6RA";
export var wrapper_email = "contacts-module--wrapper_email--33SGe";
export var wrapper_github = "contacts-module--wrapper_github--2Pmwi";
export var wrapper_linkedin = "contacts-module--wrapper_linkedin--3yHBD";
export var wrapper_instagram = "contacts-module--wrapper_instagram--1GHvD";
export var wrapper_facebook = "contacts-module--wrapper_facebook--2TY_F";